import {TableColumnsType} from 'antd';

import {Locale} from '../../../../../provider/locale/locale';
import {ReviewsAndAnswersStatisticsUnitMeasurementEnum} from '../../../../../service/reviews-and-answers-statistics/reviews-and-answers-statistics';
import {
    getAvgResponseDelayColumn,
    getRateColumn,
    getRepliedColumn,
    getRepliedPercentage,
    getSentimentColumn,
    getTotalColumn,
    getTrendColumn,
} from '../../components/table/reviews-analysis-table-helper';
import {PhrasesTableDataType} from '../../reviews-analysis-type';

export function phrasesPageColumns({
    timeUnit,
}: {
    timeUnit: ReviewsAndAnswersStatisticsUnitMeasurementEnum;
}): TableColumnsType<PhrasesTableDataType> {
    return [
        {
            title: <Locale stringKey="REVIEWS_ANALYSIS__TABLE__COLUMN__PHRASE" />,
            dataIndex: 'phrase',
            key: 'phrase',
        },
        getRateColumn<PhrasesTableDataType>(),
        getTotalColumn<PhrasesTableDataType>(),
        getRepliedColumn<PhrasesTableDataType>(),
        getRepliedPercentage<PhrasesTableDataType>(),
        getAvgResponseDelayColumn<PhrasesTableDataType>(timeUnit),
        getSentimentColumn<PhrasesTableDataType>(),
        getTrendColumn<PhrasesTableDataType>(),
    ];
}
